import {
  Heart,
  Shield,
  CheckCircle,
  Clock,
  Eye,
  Sparkles,
  Leaf,
  Target,
  Zap,
  Activity,
  Stethoscope,
  Settings,
  Calendar,
  Wind,
  Baby,
  Smile,
  Scan,
  TrendingUp,
  Palette,
  RotateCcw,
  Layers,
  Star,
  Zap as Lightning,
  Monitor,
  Users,
  Printer,
  FlaskConical,
  Search,
  RefreshCcw,
  Gauge,
  Cpu,
  Combine,
  Award,
} from "lucide-react"

export enum ServiceCategoryEnum {
  DIAGNOSTICS_PREVENTION = "diagnostics_prevention",
  THERAPEUTIC_DENTISTRY = "therapeutic_dentistry",
  AESTHETIC_SMILE = "aesthetic_smile",
  PEDIATRIC_DENTISTRY = "pediatric_dentistry",
  IMPLANTOLOGY_SURGERY = "implantology_surgery",
  ALLERGOLOGY_PHYSIOTHERAPY = "allergology_physiotherapy"
}

export interface Service {
  id: string
  icon: string
  href: string
  images: string[]|null
  category: ServiceCategoryEnum
  keyPoints: number
  howItWorksSection?: boolean
  highlights?: {
    items: number
    icons: any[]
  } | null
  benefits?: {
    items: number
    icons: any[]
  } | null
  faq: number
  doctorSpotLightIds?: string[] | null
}

export const services: Service[] = [
  /* Thermography [1] */
  {
    id: "thermography",
    icon: "/assets/images/service-icons/infrared termography-NEW.svg",
    href: "/services/thermography",
    images: null,
    category: ServiceCategoryEnum.DIAGNOSTICS_PREVENTION,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Shield,
        CheckCircle,
        Clock,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        Shield,
        Clock,
        Heart,
      ],
    },
    faq: 3,
    doctorSpotLightIds: ['raya_grozdanova']
  },
  /* Services Page - Cariology [2] */
  {
    id: "cariology",
    icon: "/assets/images/service-icons/cariesology.svg",
    href: "/services/cariology",
    images: null,
    category: ServiceCategoryEnum.THERAPEUTIC_DENTISTRY,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Eye,
        CheckCircle,
        Sparkles,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        Shield,
        Leaf,
        Heart,
      ],
    },
    faq: 7
  },
  /* Services Page - Endodontics [3] */
  {
    id: "endodontics",
    icon: "/assets/images/service-icons/endodontics.svg",
    href: "/services/endodontics",
    images: null,
    category: ServiceCategoryEnum.THERAPEUTIC_DENTISTRY,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Eye,
        Zap,
        Target,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        Activity,
        Leaf,
        Shield,
      ],
    },
    faq: 10
  },
  /* Services Page - Periodontology [4] */
  {
    id: "periodontology",
    icon: "/assets/images/service-icons/periodontology.svg",
    href: "/services/periodontology",
    images: null,
    category: ServiceCategoryEnum.THERAPEUTIC_DENTISTRY,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Stethoscope,
        Settings,
        Calendar,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        Leaf,
        Wind,
        Heart,
      ],
    },
    faq: 10
  },
  /* Services Page - Pediatric Dentistry [5] */
  {
    id: "pediatric",
    icon: "/assets/images/service-icons/pediatric dentistry.svg",
    href: "/services/pediatric",
    images: null,
    category: ServiceCategoryEnum.PEDIATRIC_DENTISTRY,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Baby,
        Smile,
        Scan,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        Shield,
        Heart,
        TrendingUp,
      ],
    },
    faq: 10
  },
  /* Services Page - Aesthetic Dentistry [6] */
  {
    id: "aesthetic",
    icon: "/assets/images/service-icons/aesthetic dentistry.svg",
    href: "/services/aesthetic",
    images: null,
    category: ServiceCategoryEnum.AESTHETIC_SMILE,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Layers,
        RotateCcw,
        Target,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        Star,
        Heart,
        Shield,
      ],
    },
    faq: 10
  },
  /* Services Page - Smile Design [7] */
  {
    id: "smile_design",
    icon: "/assets/images/service-icons/smile design-NEW.svg",
    href: "/services/smile-design",
    images: null,
    category: ServiceCategoryEnum.AESTHETIC_SMILE,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Monitor,
        Users,
        Printer,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        CheckCircle,
        Palette,
        Target,
      ],
    },
    faq: 10
  },
  /* Services Page - Dental Allergology [8] */
  {
    id: "allergology",
    icon: "/assets/images/service-icons/dental allergology.svg",
    href: "/services/allergology",
    images: null,
    category: ServiceCategoryEnum.DIAGNOSTICS_PREVENTION,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Shield,
        FlaskConical,
        Search,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        Heart,
        CheckCircle,
        RefreshCcw,
      ],
    },
    faq: 10
  },
  /* Services Page - Dental Physiotherapy [9] */
  {
    id: "physiotherapy",
    icon: "/assets/images/service-icons/dental physiotherapy.svg",
    href: "/services/physiotherapy",
    images: null,
    category: ServiceCategoryEnum.ALLERGOLOGY_PHYSIOTHERAPY,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Gauge,
        Zap,
        Clock,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        Activity,
        Leaf,
        Shield,
      ],
    },
    faq: 10
  },
  /* Dental Implantology [10] */
  {
    id: "implantology",
    icon: "/assets/images/service-icons/dental implantology.svg",
    href: "/services/implantology",
    images: null,
    category: ServiceCategoryEnum.IMPLANTOLOGY_SURGERY,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Scan,
        Target,
        Award,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        Leaf,
        Smile,
        Shield,
      ],
    },
    faq: 10,
    doctorSpotLightIds: ['todor_uzunov', 'evgeni_alexiev']
  },
  /* Services Page - Prosthetic Dentistry [11] */
  {
    id: "prosthetics",
    icon: "/assets/images/service-icons/prosthetic dentistry.svg",
    href: "/services/prosthetics",
    images: null,
    category: ServiceCategoryEnum.THERAPEUTIC_DENTISTRY,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Cpu,
        Combine,
        Palette,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        Smile,
        Leaf,
        Shield,
      ],
    },
    faq: 10
  },
  /* Oral Surgery [12] */
  {
    id: "oral_surgery",
    icon: "/assets/images/service-icons/oral surgery-NEW.svg",
    href: "/services/oral-surgery",
    images: null,
    category: ServiceCategoryEnum.IMPLANTOLOGY_SURGERY,
    keyPoints: 4,
    howItWorksSection: true,
    highlights: {
      items: 3,
      icons: [
        Heart,
        Eye,
        Activity,
      ],
    },
    benefits: {
      items: 3,
      icons: [
        Activity,
        Shield,
        Settings,
      ],
    },
    faq: 10,
    doctorSpotLightIds: ['evgeni_alexiev']
  },
];

export function getServiceBySlug(slug: string): Service | null {
  return services.find((service) => service.href.split('/').pop() === slug) || null;
}

export function getAllServices(): Service[] {
  return services
}

export function getAllServiceSlugs(): string[] {
  return services.map(service => service.href.split('/').pop() || '')
}